<template>
	<div>
		<vm-header :inputName='Name'></vm-header>
		<v-serch></v-serch>
		<v-massage></v-massage>
		<v-crumbs></v-crumbs>
		<div class="container tablecon">
			<div class="two" v-for="(item,index) in Title" :key="index">
				<div class="T_title1">{{item.til1}}</div>
				<div class="T_title2">{{item.til2}}</div>
				<div class="T_title8">
					<div class="T_title8top">{{item.til8}}</div>
					<div class="T_title8bot">
						<div>{{item.til9}}</div>
						<div>{{item.til10}}</div>
						<div>{{item.til11}}</div>
						<div>{{item.til12}}</div>
						<div>{{item.til13}}</div>
						<div>{{item.til14}}</div>
					</div>
				</div>
				<div class="T_title9">{{item.til15}}</div>
			</div>
			<div class="three">
				<div class="three_for" v-for="(item,index1) in arr" :key=index1>
					<div class="Cont Cont1">
						<div class="Cont_Nr">
							<h3>{{item.title}}</h3>
							<p>{{item.cocon}}</p>
						</div>
					</div>
					<div class="Cont Cont2">
						<p>{{item.rank}}</p>
					</div>
					<div class="Cont Cont8">
						<!-- -->
						<div :class="data.class" v-for="(data,index2) in item.arr2" :key="index2">
							<div class="Cont8_B">{{data.Cont1}}</div>
							<div class="Cont8_B">{{data.Cont2}}</div>
							<div class="Cont8_B">{{data.Cont3}}</div>
						</div>
					</div>
					<div class="Cont Cont9">
						<div :class="item.classA">
							<img :src="item.imggz" alt="">
							<p>{{item.gz}}</p>
						</div>
					</div>
		 	</div>
			</div>
		</div>
		<item7></item7>
		<zuoxuanfu1></zuoxuanfu1>
	</div>
</template>
<script>
	import zuoxuanfu1 from '../components/zuoxuanfu1.vue'
	import vSerch from '../components/vSerch.vue'
	import vmHeader from '../components/vmHeader.vue'
	import item7 from '../components/item7.vue'
	import vCrumbs from '../components/vCrumbs.vue'
	import vMassage from '../components/vMassage.vue'
	import newgaokao750 from "../../css/newgaokao750.css"


	export default {
		props: [],
		components: {
			vSerch,
			vmHeader,
			item7,
			vCrumbs,
			vMassage,
			newgaokao750,
			zuoxuanfu1
		},
		data() {
			return {
				// 导航选中
				Name:0,
				// 标题
				Title: [{
					til1: '专业名称',
					til2: '院校名称',
					til8: '近年录取统计',
					til9: '年份',
					til10: '录取数',
					til11: '最低分',
					til12: '最低位次',
					til13: '最高分',
					til14: '最高位次',
					til15: '操作',
				}],
				// 学校渲染
				arr: [{
					title: '经济学类',
					cocon: '(5000元/年；包含专业经济学、金融学、国际经济与贸易、保险学(风险管理与保险)、财政学、资源与环境经济学；办学地点校本部)	',
					rank: '中国石油大学(北京)克拉玛依校区',
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: 'Cont8_A Cont8_AA'
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: 'Cont8_A'
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: 'Cont8_A'
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: 'Cont8_A'
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: 'Cont8_A'
						},
					],
					classA: "Cont9_A",
					imggz: require('../../src/assets/img/huixing.png'),
					gz: '关注'
				}, {
					title: '数学类',
					cocon: '(5000元/年；包含专业经济学、金融学、国际经济与贸易、保险学(风险管理与保险)、财政学、资源与环境经济学；办学地点校本部)	',
					rank: '中国石油大学(北京)克拉玛依校区',
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: 'Cont8_A Cont8_AA'
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: 'Cont8_A'
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: 'Cont8_A'
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: 'Cont8_A'
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: 'Cont8_A'
						},
					],
					classA: "Cont9_A",
					imggz: require('../../src/assets/img/huixing.png'),
					gz: '关注'
				}, {
					title: '经济学类',
					cocon: '(5000元/年；包含专业经济学、金融学、国际经济与贸易、保险学(风险管理与保险)、财政学、资源与环境经济学；办学地点校本部)	',
					rank: '中国石油大学(北京)克拉玛依校区',
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: 'Cont8_A Cont8_AA'
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: 'Cont8_A'
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: 'Cont8_A'
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: 'Cont8_A'
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: 'Cont8_A'
						},
					],
					classA: "Cont9_A",
					imggz: require('../../src/assets/img/huixing.png'),
					gz: '关注'
				}, {
					title: '数学类',
					cocon: '(5000元/年；包含专业经济学、金融学、国际经济与贸易、保险学(风险管理与保险)、财政学、资源与环境经济学；办学地点校本部)	',
					rank: '中国石油大学(北京)克拉玛依校区',
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: 'Cont8_A Cont8_AA'
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: 'Cont8_A'
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: 'Cont8_A'
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: 'Cont8_A'
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: 'Cont8_A'
						},
					],
					classA: "Cont9_A",
					imggz: require('../../src/assets/img/huixing.png'),
					gz: '关注'
				}, {
					title: '经济学类',
					cocon: '(5000元/年；包含专业经济学、金融学、国际经济与贸易、保险学(风险管理与保险)、财政学、资源与环境经济学；办学地点校本部)	',
					rank: '中国石油大学(北京)克拉玛依校区',
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: 'Cont8_A Cont8_AA'
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: 'Cont8_A'
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: 'Cont8_A'
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: 'Cont8_A'
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: 'Cont8_A'
						},
					],
					classA: "Cont9_A",
					imggz: require('../../src/assets/img/huixing.png'),
					gz: '关注'
				}, {
					title: '数学类',
					cocon: '(5000元/年；包含专业经济学、金融学、国际经济与贸易、保险学(风险管理与保险)、财政学、资源与环境经济学；办学地点校本部)	',
					rank: '中国石油大学(北京)克拉玛依校区',
					arr2: [{
							Cont1: 2020,
							Cont2: 2019,
							Cont3: 2018,
							class: 'Cont8_A Cont8_AA'
						},
						{
							Cont1: 1575,
							Cont2: 1575,
							Cont3: 1575,
							class: 'Cont8_A'
						},
						{
							Cont1: 607,
							Cont2: 607,
							Cont3: 607,
							class: 'Cont8_A'
						},
						{
							Cont1: 37447,
							Cont2: 37447,
							Cont3: 37447,
							class: 'Cont8_A'
						},
						{
							Cont1: 62,
							Cont2: 62,
							Cont3: 62,
							class: 'Cont8_A'
						},
					],
					classA: "Cont9_A",
					imggz: require('../../src/assets/img/huixing.png'),
					gz: '关注'
				}],
			};
		},
		computed: {},
		methods: {},
		mounted() {},
	};
</script>
<style scoped>
	.two {
		display: flex;
		width: 100%;
		height: 100px;
		background-color: #F66464;
		margin-top: 20px;
		border-radius: 2px;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 50px;
		color: #FFFFFF;
		justify-content: center;
		align-items: center;
	}

	.two .T_title1 {
		width: 23%;
		text-align: center;
	}

	.two .T_title2 {
		width: 23%;
		text-align: center;
	}

	.two .T_title8 {
		width: 45%;
		text-align: center;
		display: flex;
		flex-direction: column;
		border-left: 1px solid rgba(255, 255, 255, 0.3);
		border-right: 1px solid rgba(255, 255, 255, 0.3);
	}

	.T_title8top {
		display: flex;
		align-items: center;
		justify-content: right;
		box-sizing: border-box;
		padding-right: 25px;
		box-sizing: border-box;
		border-bottom: 1px solid rgba(255, 255, 255, 0.3);
	}

	.T_title8bot {
		display: flex;
		justify-content: space-around;
	}

	.two .T_title9 {
		width: 9%;
		text-align: center;
	}

	/* 设置个别宽度不是以下不是此范围的样式 */
	@media (min-width:1400px) {
		.container {
			width: 1530px;
		}
	}

	/* 中间内容 */
	.three {
		width: 100%;
		height: auto;
		margin-top: 11px;
		margin-bottom: 55px;
	}

	.three .three_for {
		display: flex;
		width: 100%;
		height: 169px;
		border: 1px solid #EBE9E9;
		border-radius: 10px;
		margin-top: 11px;
	}

	.three .Cont1 {
		width: 23%;
		height: 100%;
		display: flex;
		padding-top: 10px;
		padding-left: 10px;
		padding-right: 20px;
		box-sizing: border-box;
	}

	.three .Cont {
		border-right: 1px solid #EBE9E9;
	}

	.three .Cont2 {
		width: 23%;
		height: 100%;
		text-align: center;
		line-height: 169px;
	}

	.three .Cont8 {
		width: 45%;
		height: 100%;
		box-sizing: border-box;
		display: flex;
		justify-content: space-evenly;
		border: none;
	}

	.Cont8_A {
		width: 20%;
		display: flex;
		flex-direction: column;
		justify-content: space-evenly;
		align-items: center;
		border-right: 1px solid #EBE9E9;
	}

	.Cont8_AA {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #29A7E1;
	}

	.Cont8_B {
		width: 100%;
		height: 33.33333%;
		border-bottom: 1px solid #EBE9E9;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.three .Cont9 {
		width: 9%;
		height: 100%;
		text-align: center;
		line-height: 169px;
		border: none;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.Cont9 .Cont9_A {
		display: flex;
		justify-content: center;
		width: 92px;
		height: 36px;
		background-image: url('../../src/assets/img/weiguanzhu.png');
		background-size: 92px 36px;
		align-items: center;
		cursor: pointer;
	}

	/* 点击关注 切换 */
	/* .Cont9 .Cont9_B {display:flex;justify-content:center;width:92px;height:36px;background-image:url('../../src/assets/img/yiguanzhu.png');background-size:92px 36px;align-items:center;cursor:pointer;}
*/
	.Cont9_A img {
		width: 15px;
		height: 16px;
		margin-right: 8px;
	}

	.Cont9_A p {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 20px;
		color: #666666;
	}

	.Cont_img {
		width: 110px;
		height: 110px;
	}

	.Cont_Nr {
		margin-left: 20px;
		flex: 1;
		height: 150px;
	}

	.Cont_Nr h3 {
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 34px;
		color: #29A7E1;
	}

	.Cont_Nr p {
		font-size: 16px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 24px;
		color: #666666;
	}

	.Cont_Card {
		margin-top: 12px;
	}

	.Cont_Card span {
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		line-height: 7px;
		color: #333333;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid #E8E8E8;
		padding: 10px 14px 10px 13px;
		margin-right: 12px;
		margin-top: 10px;
		display: inline-block;
		word-wrap: break-word;
		overflow: hidden;
		white-space: pre-wrap;
	}

	.three_for .Cont2 p {
		font-size: 16px;
		font-family: MicrosoftYaHei;
	}

	.Cont6 p {
		width: 92px;
		height: 36px;
		background: rgba(255, 255, 255, 0.39);
		border: 1px solid #29A7E1;
		color: #29A7E1;
		opacity: 1;
		border-radius: 5px;
		line-height: 36px;
		font-size: 16px;
	}

	.three_for .Cont3 p,
	.three_for .Cont4 p,
	.three_for .Cont5 p,
	.three_for,
	.three_for .Cont7 p {
		font-size: 16px;
		font-family: MicrosoftYaHei;
		color: #333333;
	}

	@media (max-width:750px) {
		.query {
			flex-direction: column;
			margin-top: 40px;
			margin-bottom: 55px;
		}

		.query_top {
			margin-top: 10px;
		}

		.query_top input {
			width: 220px;
		}

		.query_bot {
			margin-top: 10px;
			line-height: 37px;
		}

		.two {
			width: 1500px;
		}

		.tablecon {
			overflow: auto;
		}

		.three {
			width: 1500px;
		}
	}

	@media (max-width:980px) {
		.two {
			width: 1500px;
		}

		.tablecon {
			overflow: auto;
		}

		.three {
			width: 1500px;
		}
	}

	@media (max-width:1400px) {
		.two {
			width: 1500px;
		}

		.tablecon {
			overflow: auto;
		}

		.three {
			width: 1500px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/zhuanyefen.vue